import { SelectedSpecialtyType } from '../../MedicalSpecialties/SpecialtySelector/SpecialtyMultiSelectorComponent';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';
import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { IIconProps } from '@fluentui/react';
import { PractitionerSpecialtyAssociation } from '../../../models/Entities/PractitionerAssociations/Specialties/PractitionerSpecialtyAssociation';

// stores
import * as PractitionerSpecialtyAssociationStore from '../../../redux/middleware/PractitionerSpecialtyAssociationMiddleware';
import * as PractitionerStore from '../../../redux/middleware/PractitionerMiddleware';

//#region props
interface IProps {
  PractitionerId: string;
}

interface ConnectedProps {
  IsLoading: boolean;
  LoadedSuccessfully: boolean;
  FailOnLoad: boolean;
  ErrorOnLoad: ErrorType;

  IsAssociating: boolean;
  AssociatedSuccessfully: boolean;
  FailOnAssociate: boolean;
  ErrorOnAssociate: ErrorType;

  IsDisassociating: boolean;
  DisassociatedSuccessfully: boolean;
  FailOnDisassociate: boolean;
  ErrorOnDisassociate: ErrorType;

  SpecialtiesAssociated: PractitionerSpecialtyAssociation[];
  Practitioners: Practitioner[];
}

interface DispatchProps {
  GetSpecialtiesByPractitionerId: typeof PractitionerSpecialtyAssociationStore.actionCreators.GetSpecialtiesByPractitionerId;
  AssociatePractitionerSpecialty: typeof PractitionerSpecialtyAssociationStore.actionCreators.AssociatePractitionerSpecialty;
  DisassociatePractitionerSpecialtyById: typeof PractitionerSpecialtyAssociationStore.actionCreators.DisassociatePractitionerSpecialtyById;
  GetAllPractitioners: typeof PractitionerStore.actionCreators.GetAllPractitioners;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  SpecialtiesAssociated: state.Practitioners?.list.find(
    (practitioner: Practitioner) =>
      practitioner.userId === ownProps.PractitionerId
  )?.SpecialtiesAssociated ?? [],

  Practitioners: state?.Practitioners?.list,

  // load status
  IsLoading: state.PractitionerSpecialtyAssociations?.isLoadingAll,
  LoadedSuccessfully: state.PractitionerSpecialtyAssociations?.successLoadingAll,
  FailOnLoad: state.PractitionerSpecialtyAssociations?.failOnLoadingAll,
  ErrorOnLoad: state.PractitionerSpecialtyAssociations?.error,

  // associate status
  IsAssociating: state.PractitionerSpecialtyAssociations?.isAddingNewOne,
  AssociatedSuccessfully: state.PractitionerSpecialtyAssociations?.successAddingNewOne,
  FailOnAssociate: state.PractitionerSpecialtyAssociations?.failOnAddingNewOne,
  ErrorOnAssociate: state.PractitionerSpecialtyAssociations?.error,

  // disassociate status
  IsDisassociating: state.PractitionerSpecialtyAssociations?.isDeletingOne,
  DisassociatedSuccessfully: state.PractitionerSpecialtyAssociations?.successDeletingOne,
  FailOnDisassociate: state.PractitionerSpecialtyAssociations?.failOnDeletingOne,
  ErrorOnDisassociate: state.PractitionerSpecialtyAssociations?.error
});

export const mapDispatchToProps = {
  ...PractitionerSpecialtyAssociationStore.actionCreators,
  ...PractitionerStore.actionCreators
};

// icons
export const AddIcon: IIconProps = { iconName: 'CirclePlus' };

// functions
export function GetSelectedSpecialties(
  specialtiesAssociated: PractitionerSpecialtyAssociation[]
): SelectedSpecialtyType[] {
  return specialtiesAssociated
    ? specialtiesAssociated.map((assoc: PractitionerSpecialtyAssociation) => ({
        specialtyId: assoc.specialtyId,
        ReferenceId: assoc.id
      }))
    : [];
}
